import React from 'react';
import { TONEFILL } from '../../charts.js';
import { BODY } from '../../primitives.js';

const h = React.createElement;

/**
 * Progress to a goal as a thick round-capped arc.
 *
 * @param {object} p
 * @param {number} p.value
 * @param {number} [p.max]
 * @param {React.ReactNode} [p.label]
 * @param {React.ReactNode} [p.sub]
 * @param {'lime'|'gold'|'coral'|'blue'|'purple'|'ink'} [p.tone]
 * @param {number} [p.size]
 * @param {number} [p.thickness]
 * @param {(v: number, max: number) => React.ReactNode} [p.format]
 */
export function Ring({ value = 0, max = 100, size = 88, thickness = 11, label, sub, tone = 'lime', format }) {
  const r = (size - thickness) / 2 - 2, c = 2 * Math.PI * r, p = Math.max(0, Math.min(1, max ? value / max : 0));
  const fill = TONEFILL[tone] || tone;
  return h('div', { style: { display: 'inline-flex', alignItems: 'center', gap: 12, fontFamily: BODY } },
    h('svg', { width: size, height: size, role: 'img', 'aria-label': `${label || 'Progress'}: ${Math.round(p * 100)}%`, style: { display: 'block', transform: 'rotate(-90deg)' } },
      h('circle', { cx: size / 2, cy: size / 2, r, fill: 'none', stroke: 'var(--ink)', strokeWidth: thickness + 4 }),
      h('circle', { cx: size / 2, cy: size / 2, r, fill: 'none', stroke: 'var(--track)', strokeWidth: thickness }),
      p > 0 ? h('circle', { className: 'gx-ring', cx: size / 2, cy: size / 2, r, fill: 'none', stroke: fill, strokeWidth: thickness, strokeLinecap: 'round', strokeDasharray: `${(c * p).toFixed(1)} ${c.toFixed(1)}`, style: { '--gx-c': c.toFixed(1) } }) : null),
    label || sub ? h('div', null, h('div', { style: { fontWeight: 800, fontSize: 22, letterSpacing: '-.02em', fontVariantNumeric: 'tabular-nums' } }, format ? format(value, max) : Math.round(p * 100) + '%'), label ? h('div', { style: { fontSize: 12, fontWeight: 700 } }, label) : null, sub ? h('div', { style: { fontSize: 11.5, color: 'var(--mut2)' } }, sub) : null) : null);
}
